import { Component } from '@angular/core';
import { AuthenticationService } from './authentication/_services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  constructor(private authenticationService: AuthenticationService) {
    // 如登入發生問題，先登出清除資料
    try {
      this.authenticationService.createRouter();
    } catch (error) {
      this.authenticationService.logout();
    }
  }
}
